import { Reducer } from 'redux'
import { StateAwareThunkDispatch, ThunkResult } from 'src/utils/shared-types'
import {
  OidcUserActions,
  OidcUserStoreState,
  CONSTANTS,
} from './oidc-user-store.types'

export const oidcUserInitialState: OidcUserStoreState = {
  token: '',
}

type OidcUserReducer = Reducer<OidcUserStoreState, OidcUserActions>
export const oidcUserReducer: OidcUserReducer = (
  state = oidcUserInitialState,
  action: OidcUserActions
): OidcUserStoreState => {
  switch (action.type) {
    case CONSTANTS.GET_OIDC_USER_TOKEN:
      return { ...state, token: action.token }

    default:
      return state
  }
}

export const getOidcUser = (token: string): ThunkResult<void> => async (
  dispatch: StateAwareThunkDispatch
) => {
  dispatch({
    type: CONSTANTS.GET_OIDC_USER_TOKEN,
    token,
  })
}
